/**
 * @generated SignedSource<<6fdcd6cc760a402e1bf1217b9809d395>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type boardPage_Query$variables = Record<PropertyKey, never>;
export type boardPage_Query$data = {
  readonly boardReport: {
    readonly generatedAt: string;
    readonly seats: ReadonlyArray<{
      readonly observations: ReadonlyArray<string>;
      readonly question: string;
      readonly recommendation: string;
      readonly role: string;
    }>;
  } | null | undefined;
};
export type boardPage_Query = {
  response: boardPage_Query$data;
  variables: boardPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "generatedAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "observations",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recommendation",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "boardPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BoardReport",
        "kind": "LinkedField",
        "name": "boardReport",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BoardSeat",
            "kind": "LinkedField",
            "name": "seats",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "boardPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BoardReport",
        "kind": "LinkedField",
        "name": "boardReport",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BoardSeat",
            "kind": "LinkedField",
            "name": "seats",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5617085d14d3919a16e6d1a06b8c32ad",
    "id": null,
    "metadata": {},
    "name": "boardPage_Query",
    "operationKind": "query",
    "text": "query boardPage_Query {\n  boardReport {\n    generatedAt\n    seats {\n      role\n      observations\n      recommendation\n      question\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ca8f5ece3ff00598b75037094d493bc";

export default node;
